import { render } from "./TableActionButton.vue?vue&type=template&id=7debd287&scoped=true"
import script from "./TableActionButton.vue?vue&type=script&lang=ts"
export * from "./TableActionButton.vue?vue&type=script&lang=ts"

import "./TableActionButton.vue?vue&type=style&index=0&id=7debd287&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7debd287"

export default script